import React from 'react';
import styled from 'styled-components';
import CartDataProvider from '../../Utils/Users/CartDataProvider';
import { useNavigate } from 'react-router-dom';

const CartIcon = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate('/checkout');
  };
  const Badge = styled.span`
    position: absolute;
    top: -5px;
    right: -5px;
    background-color: red;
    color: white;
    font-size: 0.75rem;
    font-weight: bold;
    border-radius: 50%;
    padding: 0.2rem 0.4rem;
    display: ${({ count }) =>
      count > 0 ? 'inline-block' : 'none'}; /* Hide if count is 0 */
  `;
  return (
    <>
      <CartDataProvider>
        {(cart) => (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              id="nav-icons"
              onClick={handleClick}
            >
              <path
                className="primary"
                d="M7 4h14a1 1 0 0 1 .9 1.45l-4 8a1 1 0 0 1-.9.55H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z"
              />
              <path
                className="secondary"
                d="M17.73 19a2 2 0 1 1-3.46 0H8.73a2 2 0 1 1-3.42-.08A3 3 0 0 1 5 13.17V4H3a1 1 0 1 1 0-2h3a1 1 0 0 1 1 1v10h11a1 1 0 0 1 0 2H6a1 1 0 0 0 0 2h12a1 1 0 0 1 0 2h-.27z"
              />
            </svg>
            <Badge count={cart?.cart?.length}></Badge>
          </>
        )}
      </CartDataProvider>
    </>
  );
};

export default CartIcon;
